<template>
  <div class="section-container">
    <!-- <div class="cooperation_wrap">
      <div class="cooperation_tit">合作客户</div>
      <div class="cooperation_desc">持续为用户创造独特价值</div>
      <div class="cooperation_box">
        <div class="cooperation_item">
          <img :src="cooperationImgs[currentPage].src" alt="" />
        </div>
      </div>
    </div> -->
    <div class="section-title">公共数据平台</div>
   
    <div class="cooperation_bottom">
      <div class="details_show" ref="numberContainer">
        <div class="show_item">
          <div class="show_top">
            <count-to
              ref="counter1"
              :start-val="0"
              :end-val="189382"
              :duration="2500"
              :autoplay="false"
              class="number"
            ></count-to>
          </div>
          <div class="show_bottom">医疗器械产品</div>
          <div class="show_desc">柳叶云主要服务高值耗材领域，客户包括国内、进口品牌，主要产品线包括骨科、关节、创伤、齿科、心内等不同领域</div>
        </div>
        <div class="show_item">
          <div class="show_top">
            <count-to
              ref="counter2"
              :start-val="0"
              :end-val="16789"
              :duration="2500"
              :autoplay="false"
              class="number"
            ></count-to>
          </div>
          <div class="show_bottom">高值耗材专业信息</div>
          <div class="show_desc">针对高值耗材领域，专业产品信息、厂家条码信息，编码规则一直未来从业者的难题，柳叶云整合专业信息，提供经过清洗的专业数据库</div>
        </div>
        <div class="show_item">
          <div class="show_top">
            <count-to
              ref="counter3"
              :start-val="0"
              :end-val="153304"
              :duration="2500"
              :autoplay="false"
              class="number"
            ></count-to>
          </div>
          <div class="show_bottom">医疗器械经营企业</div>
          <div class="show_desc">首次经营审批及国家GSP相关法律法规中都对企业供货、销售渠道的合法性有着明确的要求，公共数据库含盖了各地的医疗器械经营企业信息</div>
        </div>
        <div class="show_item">
          <div class="show_top">
            <count-to
              ref="counter4"
              :start-val="0"
              :end-val="468"
              :duration="2500"
              :autoplay="false"
              class="number"
            ></count-to>
          </div>
          <div class="show_bottom">适用手术</div>
          <div class="show_desc">结合手术的实业务数据和大数据分析技术，系统不断收集和完善各类手术套装，指导客户提高报台服务效率</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountTo from 'vue-count-to'

export default {
  components: {
    CountTo
  },
  data() {
    return {
      cooperationImgs: [
        {
          src: require('@/assets/img/company1.45b286f.png'),
        },
        {
          src: require('@/assets/img/company2.png'),
        },
      ],
      currentPage: 0,
      observer: null,
      hasAnimated: false
    }
  },
  mounted() {
    this.initIntersectionObserver()
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    pageChange(page) {
      this.currentPage = page - 1
    },
    initIntersectionObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.startCountAnimation()
            this.hasAnimated = true
          }
        })
      }, {
        threshold: 0.5
      })

      this.observer.observe(this.$refs.numberContainer)
    },
    startCountAnimation() {
      this.$refs.counter1.start()
      this.$refs.counter2.start()
      this.$refs.counter3.start()
      this.$refs.counter4.start()
    }
  }
}
</script>

<style lang="scss" scoped>

.cooperation_bottom {

  .details_show {
    width: 80%;
    max-width: 1200PX;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    gap: 30PX;
    
    @media screen and (max-width: 768PX) {
      width: 90%;
      flex-direction: column;
      gap: 40PX;
    }

    .show_item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 30PX;
      background: $white;
      border-radius: 16PX;
      box-shadow: 0 10PX 30PX rgba(0, 0, 0, 0.05);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-10PX);
        box-shadow: 0 20PX 40PX rgba(52, 152, 219, 0.1);
      }

      .show_top {
        margin-bottom: 20PX;
        position: relative;
        
        .number {
          color: $primary-blue;
          font-size: 40PX;
          font-weight: 700;
          
          @media screen and (max-width: 768PX) {
            font-size: 32PX;
          }
        }
      }

      .show_bottom {
        color: $text-color-primary;
        font-size: 20PX;
        font-weight: 600;
        margin-bottom: 15PX;
        
        @media screen and (max-width: 768PX) {
          font-size: 18PX;
        }
      }

      .show_desc {
        color: $text-color-secondary;
        font-size: 14PX;
        line-height: 1.8;
        margin-top: 10PX;
        text-align: left;
      }
    }
  }
}
</style>